import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ProductionService } from '@app/shared/services/production.service';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { InventoryItem, InventoryService } from '@app/shared/services/inventory.service';

interface Dispatch {
  dispatched: number;
  kgsBal: number;
}
@Component({
  selector: 'app-production-info',
  templateUrl: './production-info.component.html',
  styleUrls: ['./production-info.component.css']
})
export class ProductionInfoComponent implements OnInit {
  productionForm: FormGroup;
  productionId: string;


  inventoryList: InventoryItem[] = [];


  // Mapping for Material Categories to Specifications
  materialSpecificationsMap = {
    'CLEAR BOPP ': ['CLEAR BOPP [950mm X 18Î¼m]', 'CLEAR BOPP [930mm X 18Î¼m]', 'CLEAR BOPP [720mm X 40Î¼m]'],
    'MET BOPP': ['MET BOPP 40mm * 45mm', 'MET BOPP 70mm * 90mm'],
    'ADDITIVES': ['ADDITIVES'],
    'C BOPP': ['C BOPP'],
    'CLEAR CPP': ['CLEAR CPP 5mm * 4mm', 'CLEAR CPP 7mm * 9mm'],
    'PEARLIZED BOPP': ['PEARLIZED BOPP'],
    'PET': ['PET'],
    'PET G': ['PET G'],
  };

  // Specifications based on selected category
  matSpecifications: string[] = [];


  //tabbing
  // tabActive: string = 'printing'; // Default active tab
  tabActive: string | null = null; // Default: No tab active

  savedProductionData: any[] = []; // Array to store saved production data



  isAddProduction: boolean = false;
  isInking: boolean = false;

  // Define the intervals array to hold 15-minute time slots
  timeIntervals: string[] = [];

  
  filteredInventoryList: any[] = [];  // List for filtered inventory items based on matSpecification

  tabCompletion = {
    printing: 0,
    lamination: 0,
  };

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router:Router,
    private productionService: ProductionService,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,

    private inventoryService: InventoryService,
    private cdr: ChangeDetectorRef
  ) { 
  }

  ngOnInit(): void {
     // Get the ID from the route parameters
     this.route.paramMap.subscribe(params => {
      this.productionId = params.get('id');
      this.loadProductionData();
    });

    this.initializeForm();

    this.generateTimeIntervals();
    // this.generateHourIntervals();
  }

  // Generate the time intervals in a 24-hour format
  generateTimeIntervals(): void {
    // const hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
    const minutes = ['00', '15', '30', '45', '60'];  // 15-minute intervals
    
  
      for (let m of minutes) { 
        this.timeIntervals.push(`${m}`);
      }
    
  }

  initializeForm(): void {
    this.productionForm = this.fb.group({
      addProduction: [false],
      inking: [false],
     
      materialCategory: new FormControl('CLEAR BOPP '), // Default value
      matSpecifications: new FormControl('CLEAR BOPP '), // Default specification
      
    
      matRollNo: [''],

      prodWeight: ['', Validators.required],
      prodReturn: ['', Validators.required],
      prodOutputRollNo: ['', Validators.required],
      prodOutputKg: ['', Validators.required],
      prodWaste: ['', Validators.required],
      prodFlag: ['', Validators.required],

     
      availTime:['', []],
    


      //bunch ink field
      // inkType: ['', Validators.required],
      // inkName: ['', Validators.required],
      // inkColor: ['', Validators.required],
      // inkReturn: ['', Validators.required],
      // issue: ['', Validators.required],
      //bunch ink field
      inkType: ['', []],
      inkName: ['', []],
      inkColor: ['', []],
      inkReturn: ['', []],
      issue: ['', []],

     


      orderKgs: [null, Validators.required],
      poNo: [null, Validators.required],
      clientName: [null, Validators.required],
      ticketNo: [null, Validators.required],
    
  
      refNo: [null, Validators.required],
      jobName: [null, Validators.required],
      poNumber: [null, Validators.required],

     
      shift:['', Validators.required],
     
      machine: ['', Validators.required],
       operator :['', Validators.required],
     
      timeFrom : ['00:00', Validators.required], 
     
      timeTo :['00:00', Validators.required],
      operatingTime :['', Validators.required],
      mcSpeed :[null, Validators.required],
      inkGsm :[null, Validators.required],

      //inking inking
      breakdown: [false],
     
      downTime: ['', []],  // Make these fields optional
      downTimeTime: ['', []],
      downTimeRemarks: ['', []],

    



      //for inside printing
      rolls: [false],

      // Lamination related form controls(dummytext)
  // laminationMachine: ['', []],
  // laminationFilm: ['', []],
  // laminationOperator: ['', []],
  laminationMachine: ['', Validators.required],
  laminationFilm: ['', Validators.required],
  laminationOperator: ['', Validators.required],

    });


// Watch for changes and update the progress
    this.productionForm.valueChanges.subscribe(() => {
      this.updateTabCompletion();
    });

     //for matrollno(based on matrollno it fill fetch weight(prodWeight))
     this.getInventoryList();


     //(prodweight here)
     // Listen for matRollNo changes to auto-fill related fields
     this.productionForm.get('matRollNo')?.valueChanges.subscribe((selectedRollNo) => {
       const selectedRoll = this.inventoryList.find((roll) => roll.rollNo === selectedRollNo);
       if (selectedRoll) {
         // Auto-fill other fields based on selected inventory roll
         this.productionForm.get('prodWeight')?.setValue(selectedRoll.qty);  // Example: Set quantity
         // Example: Set material description
        //  this.productionForm.get('prodFlag')?.setValue(selectedRoll.materialDescription); 
       }
       else {
        // If no matching roll is found, set prodWeight to 0
        this.productionForm.get('prodWeight')?.setValue(0);
      }
     });



    // Listen for matSpecifications changes and fetch matRollNo based on subcategory
    // this.productionForm.get('matSpecifications')?.valueChanges.subscribe((selectedSpecification) => {
    //   this.fetchMatRollNo(selectedSpecification);
    // });

     // Listen for changes in matSpecifications to filter matRollNo based on matSpecification
     this.productionForm.get('matSpecifications')?.valueChanges.subscribe((selectedSpecification) => {
      this.filterMatRollNoBySpecification(selectedSpecification);
    });

    // Set initial specifications based on the default material category
    this.setSpecifications('CLEAR BOPP ');

    // Listen for materialCategory change and update specifications
    this.productionForm.get('materialCategory')?.valueChanges.subscribe(value => {
      this.setSpecifications(value);
    });






     // Listen for changes on timeFrom and timeTo fields
     this.productionForm.get('timeFrom')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });

    this.productionForm.get('timeTo')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });




    this.productionForm.get('downTimeTime')?.valueChanges.subscribe(() => {
      this.calculateAvailableTime();
    });



       //for creating dynamic updation based on material category
     // Set initial specifications based on the default material category
     this.setSpecifications('CLEAR BOPP ');
    
     // Listen for materialCategory change and update specifications
     this.productionForm.get('materialCategory')?.valueChanges.subscribe(value => {
       this.setSpecifications(value);
     });
  }

  setSpecifications(materialCategory: string): void {
    if (this.materialSpecificationsMap[materialCategory]) {
      this.matSpecifications = this.materialSpecificationsMap[materialCategory];
      // Reset matSpecifications to the first option
      this.productionForm.patchValue({
        matSpecifications: this.matSpecifications[0]
      });
    }
  }

  filterMatRollNoBySpecification(selectedSpecification: string): void {
    // Filter inventoryList to get items matching the selected matSpecification
    this.filteredInventoryList = this.inventoryList.filter(item => item.subcategory === selectedSpecification);
    
    // Optionally, reset the matRollNo if no matching item is found
    if (this.filteredInventoryList.length === 0) {
      //without console(working)
      this.productionForm.get('matRollNo')?.setValue(null);

      // If no matching items, set matRollNo to "NA" and prodWeight to 0
      // this.productionForm.get('matRollNo')?.setValue('NA');
      // this.productionForm.get('prodWeight')?.setValue(0);
      // console.log("No matching Mat Roll No found, setting matRollNo to 'NA' and prodWeight to 0");
    }
  }

  calculateTimeDifference(): void {
    const timeFrom = this.productionForm.get('timeFrom')?.value;
    const timeTo = this.productionForm.get('timeTo')?.value;
  
    // Ensure both timeFrom and timeTo are valid before calculating
    if (timeFrom && timeTo) {
      const timeFromDate = this.convertTimeToDate(timeFrom);
      const timeToDate = this.convertTimeToDate(timeTo);
  
      // Calculate the time difference in milliseconds
      const diffInMilliseconds = timeToDate.getTime() - timeFromDate.getTime();
  
      // Convert the difference into minutes
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60)); // Minutes
  
      // Update the operatingTime field to display the time difference in minutes format
      this.productionForm.patchValue({
        operatingTime: `${diffInMinutes} minutes`  // Displaying it as "XXX minutes"
      });
  
      // Print the difference in the console in minutes format
      console.log('Operating Time Difference:', `${diffInMinutes} minutes`);
    }
  }


  //available time
calculateAvailableTime(): void {
  // Get the operating time and breakdown time from the form
  const operatingTime = this.productionForm.get('operatingTime')?.value;  // Operating time in minutes
  const downTime = this.productionForm.get('downTimeTime')?.value || '00';  // Breakdown time, default to '00' if not selected
  
  // Extract the numeric value of operatingTime (e.g., '120 minutes' to 120)
  const operatingTimeInMinutes = this.extractMinutesFromString(operatingTime);

  // Convert breakdown time to minutes (e.g., '15' to 15 minutes)
  const breakdownTimeInMinutes = this.parseTimeToMinutes(downTime);

  // Calculate available time (operating time - breakdown time)
  const availableTime = operatingTimeInMinutes - breakdownTimeInMinutes;

  // Update the availTime field in the form with the calculated available time
  this.productionForm.patchValue({
    availTime: `${availableTime} minutes`  // Display as "XXX minutes"
  });

  // Print the result in the console
  console.log('Available Time:', `${availableTime} minutes`);
}

// Helper function to extract the number of minutes from the "XXX minutes" string
extractMinutesFromString(time: string): number {
  const match = time.match(/(\d+)/);  // Extracts the numeric part from the string
  return match ? parseInt(match[0], 10) : 0;  // Returns the number of minutes, defaulting to 0
}

// Helper function to convert time (e.g., '00', '15', '30') to minutes
parseTimeToMinutes(time: string): number {
  const timeMapping = {
    '00': 0,
    '15': 15,
    '30': 30,
    '45': 45,
    '60': 60
  };
  return timeMapping[time] || 0;
}

// Helper function to convert time string to Date object
convertTimeToDate(time: string): Date {
  const [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  return date;
}

// Helper function to format hours and minutes as HH:mm
formatTime(hours: number, minutes: number): string {
  const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  return `${formattedHours}:${formattedMinutes}`;
}



// Fetch the list of inventory rolls
getInventoryList(): void {
  this.inventoryService.getAllInventry().subscribe((response) => {
    this.inventoryList = response;  // Populate the list of inventory items
  });

   // Initialize filtered list based on default matSpecification
   this.filterMatRollNoBySpecification(this.matSpecifications[0]);
}

 // Auto-fill other fields based on selected matRollNo
 autoFillFieldsForMatRollNo(selectedRollNo: string): void {
  const selectedRoll = this.inventoryList.find((roll) => roll.rollNo === selectedRollNo);
  if (selectedRoll) {
    // Auto-fill prodWeight based on selected roll
    this.productionForm.get('prodWeight')?.setValue(selectedRoll.qty);
  } else {
    // If no matching roll is found, set prodWeight to 0
    this.productionForm.get('prodWeight')?.setValue(0);
  }
}


// Method to switch between tabs
// onTabChange(tabName: string) {
//   this.tabActive = tabName;
// }
// Method to switch between tabs
onTabChange(tabName: string) {
  this.tabActive = this.tabActive === tabName ? null : tabName; // Toggle tab state
}
updateTabCompletion() {
  // Update completion status for each tab
  this.tabCompletion.printing = this.checkTabCompletion(['refNo', 'poNumber', 'clientName', 'jobName', 'orderKgs']);
  this.tabCompletion.lamination = this.checkTabCompletion(['laminationMachine', 'laminationFilm', 'laminationOperator']);
}

checkTabCompletion(fields: string[]): number {
  const completedFields = fields.filter(field => this.productionForm.get(field)?.valid);
  return Math.round((completedFields.length / fields.length) * 100);
}



// Method to save production data
saveProductionData() {
  const formValues = this.productionForm.value;

  // Capture relevant data
  const productionData = {
    matSpecifications: formValues.matSpecifications,
    matRollNo: formValues.matRollNo,
    prodFlag: formValues.prodFlag,
    prodWeight: formValues.prodWeight,
  };

  // Push to saved data array
  this.savedProductionData.push(productionData);

  // Optionally, reset specific fields after saving
  this.productionForm.patchValue({
    matSpecifications: '',
    matRollNo: '',
    prodFlag: '',
    prodWeight: '',
  });
}

savedInkData: any[] = [];

saveInkData() {
    // Capture the ink data from the form
    const inkData = this.productionForm.value;

    // Push the ink data to the savedInkData array
    this.savedInkData.push({
        inkName: inkData.inkName,
        inkColor: inkData.inkColor,
        inkType: inkData.inkType,
        issue: inkData.issue,
        inkReturn: inkData.inkReturn
    });

    // Optionally, reset the form or just the inking-specific fields
    // this.productionForm.reset();
    // Or reset only the inking section:
    this.productionForm.get('inkName').reset();
    this.productionForm.get('inkColor').reset();
    this.productionForm.get('inkType').reset();
    this.productionForm.get('issue').reset();
    this.productionForm.get('inkReturn').reset();
}

onProcessChange(process: string) {
  // Update form controls based on selected processes
  // if (process === 'extrusion') {
  //   if (this.productionForm.get('extrusion').value) {
  //     this.productionForm.addControl('extrusionJobName', this.fb.control(''));
  //     this.productionForm.addControl('extrusionClientName', this.fb.control(''));
  //     this.productionForm.addControl('extrusionOrderKgs', this.fb.control(''));
  //   } else {
  //     this.productionForm.removeControl('extrusionJobName');
  //     this.productionForm.removeControl('extrusionClientName');
  //     this.productionForm.removeControl('extrusionOrderKgs');
  //   }
  // }

 //extended table(based on process selection)
 //to select only one process
//  this.isAddProduction = process === 'addProduction';
//  this.isInking = process === 'inking';

// Update flags based on selected processes
if (process === 'addProduction') {
  this.isAddProduction = !this.isAddProduction;
} else if (process === 'inking') {
  this.isInking = !this.isInking;
}

// Dynamically add or remove form controls based on selected processes
if (this.isAddProduction) {
  this.addAddProductionFields();
} else {
  this.removeAddProductionFields();
}

if (this.isInking) {
  this.addInkingFields();
} else {
  this.removeInkingFields();
}






  if (process === 'addProduction') {
    if (this.productionForm.get('addProduction').value) {
      this.productionForm.addControl('materialCategory', this.fb.control(''));
      this.productionForm.addControl('matSpecifications', this.fb.control(''));
      this.productionForm.addControl('matRollNo', this.fb.control(''));
      this.productionForm.addControl('prodWeight', this.fb.control(''));
      this.productionForm.addControl('prodReturn', this.fb.control(''));
      this.productionForm.addControl('prodOutputRollNo', this.fb.control(''));
      this.productionForm.addControl('prodOutputKg', this.fb.control(''));
      this.productionForm.addControl('prodWaste', this.fb.control(''));
      this.productionForm.addControl('prodFlag', this.fb.control(''));

      this.productionForm.addControl('availTime', this.fb.control(''));
    } else {
      this.productionForm.removeControl('materialCategory');
      this.productionForm.removeControl('matSpecifications');
      this.productionForm.removeControl('matRollNo');
      this.productionForm.removeControl('prodWeight');
      this.productionForm.removeControl('prodReturn');
      this.productionForm.removeControl('prodOutputRollNo');
      this.productionForm.removeControl('prodOutputKg');
      this.productionForm.removeControl('prodWaste');
      this.productionForm.removeControl('prodFlag');

      this.productionForm.removeControl('availTime');
    }
  }
  if (process === 'inking') {
    if (this.productionForm.get('inking').value) {
      this.productionForm.addControl('inkType', this.fb.control(''));
      this.productionForm.addControl('inkName', this.fb.control(''));
      this.productionForm.addControl('inkColor', this.fb.control(''));
      this.productionForm.addControl('inkReturn', this.fb.control(''));
      this.productionForm.addControl('issue', this.fb.control(''));
      // this.productionForm.addControl('breakdown', this.fb.control(''));
    } else {
      this.productionForm.removeControl('inkType');
      this.productionForm.removeControl('inkName');
      this.productionForm.removeControl('inkColor');
      this.productionForm.removeControl('inkReturn');
      this.productionForm.removeControl('issue');
      // this.productionForm.removeControl('breakdown');
    }
  }
}

addAddProductionFields() {

  this.productionForm.addControl('matSpecifications', this.fb.control(''));
  this.productionForm.addControl('matRollNo', this.fb.control(''));
  this.productionForm.addControl('prodWeight', this.fb.control(''));

  this.productionForm.addControl('availTime', this.fb.control(''));
 
}

removeAddProductionFields() {
 
  this.productionForm.removeControl('matSpecifications');
  this.productionForm.removeControl('matRollNo');
  this.productionForm.removeControl('prodWeight');

  this.productionForm.removeControl('availTime');
  
}

addInkingFields() {
  this.productionForm.addControl('inkType', this.fb.control(''));
  this.productionForm.addControl('inkName', this.fb.control(''));
  this.productionForm.addControl('inkColor', this.fb.control(''));
 
}

removeInkingFields() {
  this.productionForm.removeControl('inkType');
  this.productionForm.removeControl('inkName');
  this.productionForm.removeControl('inkColor');
 
}

//Breakdown
onProcessChangeBreakdown(process: string) {
  // Update form controls based on selected processes
  if (process === 'breakdown') {
    if (this.productionForm.get('breakdown').value) {
      this.productionForm.addControl('downTime', this.fb.control(''));
      this.productionForm.addControl('downTimeTime', this.fb.control(''));
      this.productionForm.addControl('downTimeRemarks', this.fb.control(''));
    } else {
      this.productionForm.removeControl('downTime');
      this.productionForm.removeControl('downTimeTime');
      this.productionForm.removeControl('downTimeRemarks');
    }
  }
 
  
}






//rolls
onProcessChangeRolls(process: string) {
  // Update form controls based on selected processes
  if (process === 'rolls') {
    if (this.productionForm.get('rolls').value) {
      this.productionForm.addControl('downTime', this.fb.control(''));
      this.productionForm.addControl('downTimeTime', this.fb.control(''));
      this.productionForm.addControl('downTimeRemarks', this.fb.control(''));
    } else {
      this.productionForm.removeControl('downTime');
      this.productionForm.removeControl('downTimeTime');
      this.productionForm.removeControl('downTimeRemarks');
    }
  }
 
  
}


fetchUnsavedOrderData(productionId:any): void {
  console.log('Fetching unsaved order data...');
  
  this.orderDataService.getUnsavedOrderById(productionId).subscribe((orderData: any) => {
    console.log('Fetched unsaved order data:', orderData);
    




    //this.populateNewOrderFields(orderData);  // Pass orderData, not productionId
  }, error => {
    console.error('Error fetching unsaved order data:', error);
  });
}

loadProductionData(): void {
  forkJoin({
    repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    unsavedOrders: this.orderDataService.getAllUnsavedOrders()
  }).subscribe({
    next: (data) => {
      const repeatOrders = Array.isArray(data.repeatOrders) ? data.repeatOrders : [];
      const unsavedOrders = Array.isArray(data.unsavedOrders) ? data.unsavedOrders : [];
      let productionData = repeatOrders.find(order => order._id === this.productionId) ||
                         unsavedOrders.find(order => order._id === this.productionId);

      if (productionData) {
        console.log('+', productionData);
        this.populateForm(productionData);
        // Check if the order is completed
        if (productionData.status === 'Closed') {
          alert('This order has already been completed!');
          this.productionForm.disable(); // Disable the form if completed
        }
      } else {
        console.error('No production found with the given ID');
      }
    },
    error: (err) => {
      console.error('Error fetching production data', err);
    }
  });
}

populateForm(productionData: any): void {
  this.productionForm.patchValue({
    orderKgs: parseFloat(productionData.orderKgs).toFixed(2),
    clientName: productionData.clientName,
    poNo: productionData.poNo,
    ticketNo: productionData.ticketno,
    refNo: productionData.refNo,
    jobName: productionData.jobName,
    poNumber: productionData.poNo,

   
  });




  // Populate the FormArray for combinedMaterials
  // this.setCombinedMaterials(productionData.combinedMaterials);
}

onSubmit(): void {
  if (this.productionForm) {
    const formData = {
      ...this.productionForm.value,
      // Ensure `addProduction`, `inking`, and `breakdown` are arrays of objects.
      addProduction: this.isAddProduction ? [
        {
          materialCategory: this.productionForm.value.materialCategory,
          matSpecifications: this.productionForm.value.matSpecifications,
          matRollNo: this.productionForm.value.matRollNo,
          prodWeight: this.productionForm.value.prodWeight,
          prodReturn: this.productionForm.value.prodReturn,
          prodOutputRollNo: this.productionForm.value.prodOutputRollNo,
          prodOutputKg: this.productionForm.value.prodOutputKg,
          prodWaste: this.productionForm.value.prodWaste,
          prodFlag: this.productionForm.value.prodFlag,

          availTime: this.productionForm.value.availTime,
        }
      ] : [],

      inking: this.isInking ? [
        {
          inkType: this.productionForm.value.inkType,
          inkName: this.productionForm.value.inkName,
          inkColor: this.productionForm.value.inkColor,
          inkReturn: this.productionForm.value.inkReturn,
          issue: this.productionForm.value.issue
        }
      ] : [],

      breakdown: this.productionForm.value.breakdown ? [
        {
          downTime: this.productionForm.value.downTime,
          downTimeTime: this.productionForm.value.downTimeTime,
          downTimeRemarks: this.productionForm.value.downTimeRemarks
        }
      ] : []
    };

    // Send the form data
    this.productionService.addProduction(formData).subscribe(
      response => {
        console.log('production created successfully:', response);
        // Optionally reset form or perform
        this.productionForm.reset();

        // Redirect to the desired route after saving
        // this.router.navigate(['/prodRecord']);

         // After submitting, reset the form but keep specific fields intact
      // this.resetFormFields();
      },
      error => {
        console.error('Error creating production:', error);
      }
    );
  } else {
    console.log('Form is invalid:', this.productionForm.errors);
  }
}






}
